
import { TrackingKey } from '../types';

export const tracking: Record<TrackingKey, string> = {
  pixel: 'Pixel',
  enablePixel: 'Enable Pixel',
  pixelId: 'Pixel ID',
  pixelType: 'Pixel Type',
  selectPixelType: 'Select Pixel Type',
  other: 'Other',
  triggerEvent: 'Trigger Event',
  selectEvent: 'Select Event',
  onPlay: 'On Play',
  onPause: 'On Pause',
  at25Percent: 'At 25% Viewed',
  at50Percent: 'At 50% Viewed',
  at100Percent: 'At 100% Viewed',
  affiliates: 'Affiliates',
  enableAffiliateTracking: 'Enable Affiliate Tracking',
  affiliateId: 'Affiliate ID',
  vslDynamic: 'VSL Dynamic',
  vsleads: 'VSLeads',
  abTest: 'A/B Test',
  hookTrack: 'Teste de hook',
  'pixel.header.title': 'Pixel Tracking',
  'pixel.header.subtitle': 'Track conversions and important video events with tracking pixels',
  'pixel.enable.helper': 'Enable to track events and conversions on advertising platforms',
  'pixel.type.helper': 'Choose the advertising platform you want to integrate',
  'pixel.id.helper': 'Paste the pixel ID provided by the advertising platform',
  'pixel.configure': 'Configure Integration',
  'pixel.edit': 'Edit Configuration',
  'pixel.token': 'Token',
  'pixel.token.placeholder': 'Enter your token...',
  'pixel.token.helper': 'Access token provided by Facebook',
  'pixel.siteUrl': 'Site URL',
  'pixel.siteUrl.placeholder': 'https://yoursite.com',
  'pixel.siteUrl.helper': 'URL of the site where the pixel will be installed',
  'pixel.siteUrl.error': 'URL must start with https://',
  'pixel.selectVideo': 'Select Video',
  'pixel.selectVideo.placeholder': 'Choose the video to integrate',
  'pixel.modal.title': 'Configure Facebook integration',
  'pixel.modal.help': 'Need help? Click here',
  'pixel.modal.cancel': 'Cancel',
  'pixel.modal.save': 'SAVE',
  'pixel.modal.saving': 'Saving...',
  'pixel.success': 'Integration configured successfully',
  'pixel.configured': 'Integration configured successfully',
  
  // Affiliate
  'affiliate.header.title': 'Affiliates',
  'affiliate.header.subtitle': 'Enter your affiliate link to earn commissions. The HostVSL logo will automatically appear in the upper right corner of the video.',
  'affiliate.enable': 'Enable affiliate link',
  'affiliate.enable.helper': 'Displays the HostVSL logo on the player and enables redirection through your link',
  'affiliate.url.label': 'Your affiliate link',
  'affiliate.url.placeholder': 'https://hostvsl.com/?ref=YOUR_ID',
  'affiliate.url.helper': 'Paste the complete HostVSL link with your affiliate ID. We will open it in a new tab when the user clicks the logo.',
  'affiliate.url.required': 'The affiliate link is required when the feature is enabled.',
  'affiliate.url.invalid': 'Enter a valid link starting with http:// or https://.',
  'affiliate.url.validation': 'This link does not appear to be valid. Please check and try again.',
  'affiliate.advanced': 'Advanced options',
  'affiliate.showOnMobile': 'Show logo on mobile too',
  'affiliate.hoverOpacity': 'Opacity on hover',
  'affiliate.displayDelay': 'Appear after video starts',
  'affiliate.delay.immediate': 'Immediate'
};
